import React from "react";
import Form, {
  Item,
  GroupItem,
  RequiredRule,
  Label,
} from "devextreme-react/form";
import LoadPanel from "devextreme-react/load-panel";
import { DateBox } from "devextreme-react";
import { formatMessage } from "devextreme/localization";
import {
  isValidRestTime,
  calculateRestDurationInMinutes,
} from "../../../services/overtime";
import "./style.scss";

export default function EarlyLate({ formData, shiftTimeIn, shiftTimeOut }) {
  const [timeIn, setTimeIn] = React.useState(null);
  const [timeOut, setTimeOut] = React.useState(null);
  const [totalHours, setTotalHours] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    // Recalculate total hours when ShiftTimeIn or ShiftTimeOut changes
    if (timeIn && timeOut) {
      caculateTotalHours(timeIn, timeOut);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shiftTimeIn, shiftTimeOut]);

  const caculateTimeIn = (payload) => {
    setTimeIn(payload);
    formData.current.TimeIn = payload;

    if (!formData.current.TimeOut) {
      return;
    }

    caculateTotalHours(payload, formData.current.TimeOut);
  };

  const caculateTimeOut = (payload) => {
    setTimeOut(payload);
    formData.current.TimeOut = payload;

    if (!formData.current.TimeIn) {
      return;
    }

    caculateTotalHours(formData.current.TimeIn, payload);
  };

  const caculateTotalHours = (timeIn, timeOut) => {
    // Check if it's a night shift
    const isNightShift = timeIn > timeOut;

    let totalHours = Math.round(timeOut - timeIn) / 36e5; // 36e5 = milliseconds in an hour

    // Adjust total hours for night shift
    if (isNightShift) {
      totalHours = 24 + totalHours;
    }

    // Check time in and time out is in ShiftTimeIn and ShiftTimeOut
    const validRestTime = isValidRestTime(
      new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        timeIn.getHours(),
        timeIn.getMinutes(),
        timeIn.getSeconds()
      ),
      new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        timeOut.getHours(),
        timeOut.getMinutes(),
        timeOut.getSeconds()
      ),
      // timeOut,
      formData.current?.Shift?.RestStart,
      formData.current?.Shift?.RestEnd
    );

    if (
      validRestTime &&
      formData.current?.Shift?.RestStart &&
      formData.current?.Shift?.RestEnd
    ) {
      const restTime = calculateRestDurationInMinutes(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate(),
          timeIn.getHours(),
          timeIn.getMinutes(),
          timeIn.getSeconds()
        ),
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate(),
          timeOut.getHours(),
          timeOut.getMinutes(),
          timeOut.getSeconds()
        ),
        formData.current?.Shift?.RestStart,
        formData.current?.Shift?.RestEnd
      );
      totalHours -= restTime;
    }
    // Update the state with the total hours
    setTotalHours(totalHours);
    formData.current.TotalHours = totalHours;
  };

  const handleCheckBreakTime = (e) => {
    setLoading(true);
    formData.current.IsBreakTime = e.value;

    if (e.value && formData.current.Shift != null) {
      // formData.current.Shift = null;
      setTimeIn(formData.current.Shift?.RestStart);
      setTimeOut(formData.current.Shift?.RestEnd);
      let totalHours =
        (formData.current.Shift?.RestEnd - formData.current.Shift?.RestStart) /
        36e5;
      setTotalHours(totalHours);
      formData.current.TimeIn = formData.current.Shift?.RestStart;
      formData.current.TimeOut = formData.current.Shift?.RestEnd;
      formData.current.TotalHours = totalHours;
      setLoading(false);
      return;
    }
    setTimeOut(null);
    setTimeIn(null);
    setTotalHours(0);
    formData.current.TotalHours = 0;
    setLoading(false);
  };

  return (
    <div>
      <LoadPanel visible={loading} />
      <Form
        colCount={2}
        id="form-overtime"
        formData={formData.current}
        className={"form-editor mb-1 mt-1"}
      >
        <GroupItem>
          <Item
            editorType="dxNumberBox"
            dataField="TotalHours"
            disabled={true}
            // defaultValue={isAssigned ? 0 : 8}
            editorOptions={{
              min: 0.25,
              value: totalHours,
              searchEnabled: true,
              onValueChanged: (e) => {
                setTotalHours(e.value);
                formData.current.TotalHours = e.value;
              },
            }}
          >
            <RequiredRule />
            <Label text={formatMessage("HoursEarly")} />
            {/* <RequiredRule message={formatMessage("ValidateTotalHours")} /> */}
          </Item>
          <Item
            editorType="dxCheckBox"
            dataField="IsBreakTime"
            editorOptions={{
              onValueChanged: handleCheckBreakTime,
              value: formData.current.IsBreakTime,
            }}
          >
            <Label text={formatMessage("IsBreakTime")} />
            {/* <RequiredRule message={formatMessage("ValidateTotalHours")} /> */}
          </Item>
        </GroupItem>
        <GroupItem>
          <Item dataField="TimeIn" disabled={formData.current.IsBreakTime}>
            <Label text={formatMessage("TimeIn")} />
            <DateBox
              onValueChange={caculateTimeIn}
              displayFormat={"HH:mm"}
              value={timeIn}
              type="time"
              pickerType="calendar"
              interval={30}

              // searchEnabled={true}
            ></DateBox>
            <RequiredRule message={formatMessage("ValidateTimeIn")} />
          </Item>
          <Item dataField="TimeOut" disabled={formData.current.IsBreakTime}>
            <Label text={formatMessage("TimeOut")} />
            <RequiredRule />
            <DateBox
              onValueChange={caculateTimeOut}
              displayFormat={"HH:mm"}
              value={timeOut}
              type="time"
              pickerType="calendar"
              interval={30}
              // disabled={true}
              // searchEnabled={true}
            >
              <RequiredRule message={formatMessage("ValidateTimeOut")} />
            </DateBox>
          </Item>
        </GroupItem>
      </Form>
    </div>
  );
}
